'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var SELECT_FILES = exports.SELECT_FILES = 'Select Files';
var CLEAR_FILES = exports.CLEAR_FILES = 'Clear Files';
var UPLOAD_FILES = exports.UPLOAD_FILES = 'Upload Files';
var REMAINING_LABEL = exports.REMAINING_LABEL = 'remaining';
var CONNECTION_ERROR = exports.CONNECTION_ERROR = 'Can\'t connect to the end point. Please check the targetUrl prop value or your internet connectivity.';
var UPLOADED = exports.UPLOADED = 'uploaded';
var QUEUED = exports.QUEUED = 'queued';
var UPLOADING = exports.UPLOADING = 'uploading';

var UPLOAD = exports.UPLOAD = 'Upload';